<script>
import resources from './resources'

export default {
  name: 'policy',
  mixins: [resources]
}
</script>

<template lang="pug">
  html
    body
      #header
        #menu-wrapper.container-fluid
          .container
            #logo.col-sm-3.col-md-2
              a(href="http://site.medibook.com.br/patient/loading-page/index")
                img(src='/static/images/logo.svg', width='164', height='50')
            ul#menu.col-sm-8.col-md-10
              a(href='http://site.medibook.com.br/patient/loading-page/index#apresentacao')
                li.apresentacao Apresenta&ccedil;&atilde;o
                a(href='http://site.medibook.com.br/patient/loading-page/index#beneficios')
                  li.beneficios Beneficios
              a(href='http://site.medibook.com.br/patient/loading-page/index#contato')
                li.contato Contato
              router-link#login.pull-right(:to="{ name: 'auth.login'}")
                | Entrar
                span.icon &#xE92E;
      #menu-mobile-icon.menu-mobile-off(:class="{'menu-mobile-on': mobileMenuOn}", @click.prevent='mobileMenuOn = !mobileMenuOn')
        .first-line
        .second-line
        .third-line
      #menu-mobile.menu-mobile-off(:class="{'menu-mobile-on': mobileMenuOn}")
        ul
          a(href='http://site.medibook.com.br/patient/loading-page/index#apresentacao')
            li.apresentacao Apresentação
          a(href='http://site.medibook.com.br/patient/loading-page/index#beneficios')
            li.beneficios Beneficios
          a(href='http://site.medibook.com.br/patient/loading-page/index#contato')
            li.contato Contato
          .line
          router-link(:to="{name: 'terms.term'}")
            li Termos de Uso
          router-link(:to="{name: 'terms.policy'}")
            li Pol&iacute;ticas de Privacidade
      #login-mobile
        .container
          .col-xs-12
            router-link.button(:to="{ name: 'auth.login'}")
              | Entrar
              span.icon &#xE92E;
      #session
      .container.professional-public
        div(style=" padding: 20px")
          .col-xs-12.white-bg.professional-profile
            .row
              .col-xs-12.col-sm-4.col-md-2
                div
                  .profile-photo
                    img.img-circle(src='/static/images/medico1.jpg')
                  .links
                    ul
                      a(href='http://wwwlinkedin.com', target="_blank")
                        li
                            img(src='/static/images/icons/linkedin-icon.svg')
                      a(href='#')
                        li
                          img(src='/static/images/icons/perfil-icon.svg')
                      a(href='http://www.lattes.com.br', target="_blank")
                        li
                          img(src='/static/images/icons/share-icon.svg')

              .col-xs-12.col-sm-8.col-md-5.profissional-info.professional-profile-modal-serach
                h6(style="font-size: 16px;")
                  | Nome do professional XXXX
                br
                span.crm CRM 898898 &nbsp; - &nbsp; PR
                .info Especiadade
                .info Estabelecimento  &mdash; Tipo
                .adress
                  | Rua Teste
                  br
                  | Rua label 2
                .planos
                  |Componente de convenios

                //-.consulta-particular(v-if="profile.price")
                    small.mb-cursor-point.price-search(@click.prevent="isShowPrice = !isShowPrice")
                      span.icon 
                      | Consulta Particular

                    div(v-show="isShowPrice", style="margin-left: 10px;")
                      span.rs R$
                      span.valor {{ profile._parsed.price_real }}
                      span.cents ,{{ profile._parsed.price_cents }}
                      span.cents(v-if="!profile._parsed.price_cents")
                        | 00

              .col-xs-12.col-sm-5.col-md-offset-0
                .agendas
                  .h5-title
                    h5 Agendas Disponíveis
                     //-schedule(:agenda="profile")
            .row
              .col-xs-12.col-sm-8.col-md-12.col-md-offset-0
                .h5-title
                  h5 Localização
                  //- maps(:latitude='profile.address.latitude', :longitude='profile.address.longitude', v-if="profile.address.latitude && profile.address.longitude")

              .col-xs-12.col-sm-8.col-md-8.formacao-profissional
                .h5-title
                  h5 Formação Profissional

                  //- specializations(:specialization="specialization", v-for="specialization in profile.professional.specializations", :key="specialization.id")
                hr
                 //- graduations(:graduation='graduation',  v-for='graduation in profile.professional.graduations', :key="graduation.id")

              .col-xs-12.col-sm-8.col-md-4.formacao-profissional
                .fotos-prestador
                  .h5-title
                    h5 Mais fotos deste Prestador
                  .gallery
                    .columns
                      div
                        img.img-rounded(src='/static/images/consultorio.jpg', alt='Consultório')

              .col-xs-12.col-sm-8.col-sm-offset-4.hidden-md.hidden-lg.text-left
      footer-patient
</template>

<style scoped>
import('../static/css/bootstrap.min.css')
* {
    margin: 0;
    padding: 0;
}

 .bottom-200 {
   margin-bottom: 200px;
 }

 .bottom-400 {
   margin-bottom: 20px;
   height: 100%;
 }

 .bott

 .bottom-800 {
   margin-bottom: 800px;
 }
.center-div
{
     padding-top: 250px;
     margin: 0 auto;
     width: 100px;
}

html,
body {
    width: 100%;
    height: 100%;
}

body {
    font-family: 'Open Sans', sans-serif;
    -webkit-transition: opacity ease .3s;
    transition: opacity ease .3s;
}

.blue-addon {
    color: #fff;
    background: #2071b8;
    border: 1px solid #2071b8;
}

span.icon {
    font-family: 'agenda-font-icons';
    margin: 0px 5px;
}

h1,
h2 {
    font-family: 'Fira Sans', sans-serif;
}

.padding-t-l-r-b {
  padding: 10px;
}

/* HEADER */

#header {
    position: fixed;
    width: 100%;
    top: 0px;
    z-index: 10;
}


/* Switch */

#switch-page {
    background: #333344;
    overflow: hidden;
}

#switch-page a {
    color: #ffffff;
    font-size: 13px;
    font-weight: 300;
    padding: 3px 0px;
    margin: 5px 0px;
    position: relative;
    border-bottom: 1px solid #333344;
    text-decoration: none;
    -webkit-transition: border ease .3s;
    transition: border ease .3s;
}

#switch-page a:hover {
    border-bottom: 1px solid #2071b8;
}


/* Menu Desk */

#menu-wrapper {
    background: #ffffff;
    border-bottom: 1px solid #f2f2f3;
    -webkit-box-shadow: 0px 3px 10px rgba(0, 0, 0, .01);
    box-shadow: 0px 3px 10px rgba(0, 0, 0, .01);
}

#menu-wrapper #logo {
    margin-top: 20px;
    height: 40px;
    padding-left: 0;
}

#menu-wrapper #menu {
    padding: 0px;
    margin: 0px;
}

#menu-wrapper #menu a {
    display: inline-block;
    cursor: pointer;
}

#menu-wrapper #menu li {
    display: inline-block;
    padding: 35px 25px;
    font-size: 16px;
    color: #333344;
    border-bottom: 1px solid #ffffff;
    -webkit-transition: border ease .3s, color ease .3s;
    transition: border ease .3s, color ease .3s;
}

#menu-wrapper #menu li:hover {
    color: #2071b9;
}

#menu-wrapper #menu li.active {
    color: #2071b9;
    border-bottom: 2px solid #2071b9;
    margin-bottom: -1px;
}

#menu-wrapper #login {
    color: #ffffff;
    background: #0c6bb5;
    border-radius: 50px;
    padding: 5px 15px 5px 25px;
    font-size: 16px;
    margin: 30px 0px;
    font-weight: 300;
    -webkit-transition: color ease .3s, padding ease .3s;
    transition: color ease .3s, padding ease .3s;
    cursor: pointer;
}

#menu-wrapper #login:hover {
    background: #2071b9;
    padding: 5px 10px 5px 30px;
}

#menu-mobile-icon {
    width: 20px;
    height: 20px;
    padding: 10px;
    position: fixed;
    right: 8.333%;
    top: 65px;
    z-index: 15;
    display: none;
}

#menu-mobile-icon .first-line {
    width: 20px;
    height: 2px;
    background: #333344;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-transition: top ease .3s, left ease .3s, -webkit-transform ease .3s;
    transition: top ease .3s, left ease .3s, -webkit-transform ease .3s;
    transition: transform ease .3s, top ease .3s, left ease .3s;
    transition: transform ease .3s, top ease .3s, left ease .3s, -webkit-transform ease .3s;
}

#menu-mobile-icon .second-line {
    width: 20px;
    height: 2px;
    background: #333344;
    position: absolute;
    top: 9px;
    left: 0;
    -webkit-transition: top ease .3s, left ease .3s, -webkit-transform ease .3s;
    transition: top ease .3s, left ease .3s, -webkit-transform ease .3s;
    transition: transform ease .3s, top ease .3s, left ease .3s;
    transition: transform ease .3s, top ease .3s, left ease .3s, -webkit-transform ease .3s;
}

#menu-mobile-icon .third-line {
    width: 20px;
    height: 2px;
    background: #333344;
    position: absolute;
    top: 18px;
    left: 0;
    -webkit-transition: top ease .3s, left ease .3s, -webkit-transform ease .3s;
    transition: top ease .3s, left ease .3s, -webkit-transform ease .3s;
    transition: transform ease .3s, top ease .3s, left ease .3s;
    transition: transform ease .3s, top ease .3s, left ease .3s, -webkit-transform ease .3s;
}

#menu-mobile-icon.menu-mobile-on .first-line {
    -webkit-transform: rotate(45deg) !important;
    transform: rotate(45deg) !important;
    top: 9px;
}

#menu-mobile-icon.menu-mobile-on .second-line {
    width: 2px;
    left: 9px;
}

#menu-mobile-icon.menu-mobile-on .third-line {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 9px;
}

#menu-mobile {
    width: 300px;
    height: 100%;
    background: #ffffff;
    -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, .5);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, .5);
    position: fixed;
    top: 0;
    right: -350px;
    z-index: 14;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 125px 30px 30px 30px;
    display: none;
    -webkit-transition: right ease .3s;
    transition: right ease .3s
}

#menu-mobile.menu-mobile-on {
    right: 0;
}

#menu-mobile a {
    -webkit-transition: color ease .3s;
    transition: color ease .3s;
}

#menu-mobile li {
    list-style: none;
    padding: 10px 0px;
    font-size: 16px;
    color: #333344;
    border-bottom: 1px solid #fff;
}

#menu-mobile li.active {
    color: #2071b9;
    border-bottom: 2px solid #2071b9;
}

#menu-mobile a:hover {
    text-decoration: none;
}

#menu-mobile a:hover li {
    color: #2071b9;
}

#menu-mobile .line {
    width: 100%;
    height: 1px;
    background: #f2f2f3;
}

#login-mobile {
    width: 100%;
    padding: 10px;
    position: fixed;
    z-index: 12;
    bottom: 0;
    left: 0;
    background: #ffffff;
    -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, .25);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, .25);
    display: none;
}

#login-mobile .button {
    color: #ffffff;
    background: #0c6bb5;
    border-radius: 50px;
    padding: 5px 15px 5px 25px;
    font-size: 16px;
    font-weight: 300;
    -webkit-transition: color ease .3s, padding ease .3s;
    transition: color ease .3s, padding ease .3s;
    cursor: pointer;
    text-align: center;
}


/* CONTEÚDO */


select::-ms-expand {
    display: none;
}

select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
}

.blue-addon {
    color: #FFFFFF;
    background: #0c6bb5;
    border: 1px solid #0c6bb5;
}

/* Apresentação */

#apresentacao {
    background: #f7f7f7;
    padding: 140px 0px 60px 0px;
}

.professional-public {
    background-color: #fff;
    margin-top: 140px;
    margin-bottom: 50px;
    text-align: justify;
}

.professional-public h4 {
  font-size: 22px;
}

#apresentacao h2 {
    font-size: 38px;
    color: #333344;
    font-weight: 300;
    position: relative;
    margin-top: 30px;
    margin-bottom: 60px;
}

#apresentacao h2:after {
    content: "";
    position: absolute;
    width: 30px;
    height: 2px;
    background: #ccc;
    bottom: -15px;
    left: 0px;
}

#apresentacao .item {
    width: 90%;
    margin: 15px 5%;
    padding: 30px 45px;
    background: #ffffff;
    border-radius: 10px;
    text-align: center;
    color: #878787;
    min-height: 260px;
    cursor: default;
    -webkit-transition: box-shadow ease .3s;
    -webkit-transition: -webkit-box-shadow ease .3s;
    transition: -webkit-box-shadow ease .3s;
    transition: box-shadow ease .3s;
    transition: box-shadow ease .3s, -webkit-box-shadow ease .3s;
}

#apresentacao .item:hover {
    -webkit-box-shadow: 0px 3px 10px rgba(0, 0, 0, .1);
    box-shadow: 0px 3px 10px rgba(0, 0, 0, .1);
}

#apresentacao .item strong {
    color: #666666;
}

#apresentacao .item .icon {
    margin-bottom: 30px;
    position: relative;
}

#apresentacao .item .icon:after {
    content: "";
    position: absolute;
    width: 45px;
    height: 2px;
    background: #2071b8;
    left: 50%;
    margin-left: -22px;
    bottom: -15px;
}

#apresentacao .item p {
    font-size: 20px;
}


/* Highlight */

#highlight {
    background: #f7f7f7;
    padding-top: 90px;
    padding-bottom: 90px;
    position: relative;
    z-index: 1;
    overflow: hidden;
    height: 440px;
}

#highlight:after {
    content: '';
    position: absolute;
    background: #2080cd;
    background: -webkit-gradient(linear, left top, right bottom, from(#2080cd), to(#164ac4));
    background: linear-gradient(to bottom right, #2080cd, #164ac4);
    width: 100%;
    height: 100%;
    top: 40px;
    left: 0;
    z-index: -1;
}

#highlight h2 {
    font-size: 38px;
    font-weight: 300;
    color: #ffffff;
    position: relative;
    margin-bottom: 30px;
}

#highlight h2 strong {
    font-weight: 400;
}

#highlight h2:after {
    content: "";
    position: absolute;
    width: 30px;
    height: 2px;
    background: #ffffff;
    left: 0px;
    bottom: -15px;
}

#highlight p {
    color: #ffffff;
    font-size: 20px;
    font-weight: 300;
}

#highlight img {
    max-width: 110%;
    position: relative;
    margin-top: -100px;
    image-rendering: crisp-edges;
}



/* Depoimento */

#quote {
    background: url(/static/depoimento.png) no-repeat center center;
    background-size: cover;
    padding-top: 120px;
    padding-bottom: 120px;
}

#quote blockquote {
    color: #333344;
    font-size: 24px;
    font-family: 'Fira Sans', sans-serif;
    font-style: italic;
    line-height: 180%;
    position: relative;
    font-weight: 300;
    padding: 0;
    border: none;
}

#quote blockquote:before {
    content: '“';
    color: #e7e7e7;
    font-size: 260px;
    position: absolute;
    font-style: normal;
    font-weight: 500;
    top: 60px;
    left: -120px;
}

#quote span {
    color: #2071b6;
    font-size: 16px;
}

@media (max-width:1200px) {
    #highlight {
        height: 420px;
    }
    #highlight img {
        margin-top: -30px;
    }
}

@media (max-width:992px) {
    .professional-public {
        background-color: #fff;
        margin-top: 85px;
        margin-bottom: 5px;
        text-align: justify;
    }
    #menu-wrapper #menu {
        margin-left: 15px;
    }
    #menu-wrapper #menu li {
        padding: 35px 15px
    }
    #intro .content {
        height: 225px;
    }
    #intro .content .text {
        margin-bottom: 15px;
    }
    #intro .input-group {
        margin-bottom: 15px;
    }
    #intro .content #search {
        margin-top: 5px;
    }
    #apresentacao .item {
        min-height: 280px;
        margin-bottom: 30px
    }
    #highlight {
        height: 650px;
    }
    #highlight img {
        margin-top: 0px;
    }
    #footer {
        text-align: center;
    }
    #footer .title:after {
        left: 50%;
        margin-left: -7px
    }
    #footer a {
        display: inline-block;
        margin: 15px 10px
    }
    #footer .copyright {
        margin-top: 15px;
    }
}

@media (max-width:767px) {
    #menu-mobile-icon {
        top:36px;
    }
    #menu-wrapper {
        height: 80px;
    }
    #menu-wrapper #logo {
        margin-top: 15px;
        text-align: center;
    }
    #menu-mobile,
    #menu-mobile-icon,
    #login-mobile {
        display: block
    }
    #intro {
        height: calc(100% - 80px);
        margin-top: 80px;
    }
    #menu-wrapper #menu,
    #menu-wrapper #login {
        display: none;
    }
    #intro {
        position: relative;
        background: url(/static/hero-paciente-mobile.jpg) no-repeat center right;
        background-size: cover;
    }
    #intro .container {
        position: relative;
        z-index: 2
    }
    #intro:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        bottom: 0;
        left: 0;
        background: url(/static/white-grad.png) no-repeat bottom left;
        background-size: 100% 100%;
        opacity: .75;
        z-index: 1;
    }
    #intro .content {
        bottom: 60px
    }
    #intro .content h1 {
        text-shadow: 0px 2px 5px #ffffff;
        font-size: 24px;
    }
    #intro .content h1:after {
        bottom: -10px;
    }
    #intro .content .text {
        font-size: 16px;
    }
    #intro .content #search {
        margin-top: 15px
    }

    .results .item{padding-left: 5%;padding-right: 5%;}
    .results .item .padding{padding: 30px 0px 0px 0px;}
    .results .item h4 span{display: block;margin-top: 7px;}
    .results .item h4 span:after{left: 105px;}
    .results-per-page{margin-top: 20px; text-align: left;padding: 0px 25px;}
    .search-specs, .results .item h4,.results .item .results .adress{padding: 0px 10px;}
    #planos, #consulta-particular{margin-top: 15px;padding: 0px 15px;}
    .results .border-top{margin: 10px 0px;}
    #agendar-consulta.desktop{display: none;}
    #agendar-consulta.mobile{display: block; float: none; margin: 30px auto; text-align: center; overflow: hidden; width: 200px;}
    .results .item .info{padding: 5px 10px;}
    #results button.see-more{width: 100%;}
    #apresentacao {
        padding: 30px 0px;
    }
    #apresentacao h2 {
        text-align: center;
        margin-bottom: 30px
    }
    #apresentacao h2:after {
        left: 50%;
        margin-left: -15px
    }
    #apresentacao .item {
        min-height: 0
    }
    #apresentacao .item small {
        font-size: 100%;
    }
    #highlight {
        padding-top: 45px;
        padding-bottom: 0px;
        height: auto;
        background: #2080cd;
        background: -webkit-gradient(linear, left top, right bottom, from(#2080cd), to(#164ac4));
        background: linear-gradient(to bottom right, #2080cd, #164ac4);
    }
    #highlight:after {
        display: none
    }
    #highlight img {
        width: 100%
    }
    #beneficios {
        padding-top: 60px
    }
    #beneficios .item {
        text-align: center
    }
    #beneficios p:after {
        left: 50%;
        margin-left: -15px;
    }
    #quote blockquote:before {
        left: 0;
        top: 0
    }
    #quote {
        padding-bottom: 60px
    }
    #contato .menina {
        display: none
    }
}
</style>



// WEBPACK FOOTER //
// src/app/profile-public/professional/index.vue